<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="p01"><a id="page10"></a><a id="page11"></a>Matriarch</h1>
<div class="block">
<p class="nonindent">‘I speak the truth, not so much as I would, but as much as I dare; and I dare a little more, as I grow older.’</p>
<p class="right">M<span class="small">ONTAIGNE</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795338557_epub_p01_r1.vue?47c7c693